import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AnalyticsData } from '../login-authentication-screen/models/login-credentials.interface';
import { loginHelpScreenView } from './models/login-help-screen.interface';

@Component({
  selector: 'idp-login-help-screen',
  templateUrl: './login-help-screen.component.html',
  styleUrls: ['./login-help-screen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginHelpScreenComponent implements OnInit {
  @Input() pageData!: loginHelpScreenView | undefined | null;
  @Input() machCore = false;
  @Output() nextDisplayView: EventEmitter<string> = new EventEmitter<string>();
  @Output() redirectTrackingClick: EventEmitter<AnalyticsData> =
    new EventEmitter<AnalyticsData>();

  @Output() triggerClose = new EventEmitter();

  pageLoadStartTime: number;
  constructor() {
    this.pageLoadStartTime = performance.now();
  }

  ngOnInit() {
    if (this.pageLoadStartTime) {
      this.redirectTrackingClick.emit({
        action: 'Login Help',
        eventDetails: 'pageLoad',
        startTime: this.pageLoadStartTime
      });
    }
  }

  resetPassword() {
    const value =
      this.pageData?.loginHelpScreenView?.nextDisplayView
        ?.nextViewName_resetPassword;
    this.redirectTrackingClick.emit({ action: value });
    this.nextDisplayView.emit(value);
  }

  sendLogin() {
    const value =
      this.pageData?.loginHelpScreenView?.nextDisplayView
        ?.nextViewName_sendLogin;
    this.redirectTrackingClick.emit({ action: value });
    this.nextDisplayView.emit(value);
  }

  createPassword() {
    const value =
      this.pageData?.loginHelpScreenView?.nextDisplayView
        ?.nextViewName_createPassword;
    this.redirectTrackingClick.emit({ action: value });
    this.nextDisplayView.emit(value);
  }
}
